/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { FaUser } from "react-icons/fa6";
import { IoSettingsSharp } from "react-icons/io5";
import { MdKeyboardArrowDown } from "react-icons/md";
import { useCurrentuser } from "../../../hooks/useUser";
import { IoLogOut } from "react-icons/io5";
import { Avatar, AvatarFallback, AvatarImage } from "@radix-ui/react-avatar";
import { Link } from "react-router-dom";
import AuthController from "../../../controllers/auth";
import { useEnums } from "../../../hooks/useEnums";
// import ToastController from "../../../controllers/ToastController";
const userDropDownData = [
  // {
  //   title: `Profile`,
  //   icon: <FaUser className="text-lg" />,
  //   link: `/profile`,
  // },
  {
    title: `Settings`,
    icon: <IoSettingsSharp className="text-lg" />,
    link: `/settings`,
  },
];
const handleLogOut = () => {
  const res = AuthController.logout();
  // ToastController.success("Logout Successfully");
};

const UserDropdown = () => {
  const [isOpen, setIsOpen] = useState(false);
  const user = useCurrentuser();
  const awsUrl = useEnums();
  return (
    <DropdownMenu open={isOpen} onOpenChange={setIsOpen}>
      <DropdownMenuTrigger
        className={`outline-none text-[#6C757D] active:text-primary transition-all duration-300`}
      >
        <div className="flex items-center sm:gap-3 sm:translate-y-0 translate-y-[-2px]">
          <Avatar>
            <AvatarImage
              className="max-w-[40px] w-full"
              src={`${awsUrl}${user?.profilePhoto?.image?.key}`}
            />
            <AvatarFallback>
              <span className="text-sm sm:text-base">CA</span>
            </AvatarFallback>
          </Avatar>
          <MdKeyboardArrowDown className="dark:text-white sm:translate-y-0 translate-y-[2px] sm:text-base text-sm text-black" />
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className={`absolute text-white py-4 px-3 top-1 flex flex-col gap-2 -right-7 min-w-max w-full rounded-2xl  dark:shadow-none drop-shadow-none border-none dark:bg-dark3 bg-white shadow-xl`}
      >
        {userDropDownData?.map((ls, index) => (
          <DropdownMenuItem key={index}>
            <Link
              to={ls?.link}
              onClick={() => {
                setIsOpen(false);
              }}
              className="flex items-center gap-2 text-sm text-black transition-all duration-300 cursor-pointer dark:text-white hover:text-primary font-lato_medium"
            >
              <div className="">{ls?.icon}</div>
              <p>{ls?.title}</p>
            </Link>
          </DropdownMenuItem>
        ))}
        <div className="h-[1px] content-[' '] w-full !text-[rgba(27,32,37,1)] dark:!bg-[rgba(27,32,37,1)] bg-white" />
        <DropdownMenuItem>
          <div
            onClick={() => {
              handleLogOut();
              setIsOpen(false);
            }}
            className="flex items-center gap-2 text-sm text-black cursor-pointer dark:text-white font-lato_medium"
          >
            <IoLogOut className="text-lg text-[#FF3F3F]" />
            <p>Logout</p>
          </div>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default UserDropdown;
